import type { ReactElement } from 'react';

export interface CalendarHeaderProps {
  monthLabel: string;
  onPrev: () => void;
  onToday: () => void;
  onNext: () => void;
}

export function CalendarHeader({
  monthLabel,
  onPrev,
  onToday,
  onNext,
}: CalendarHeaderProps): ReactElement {
  return (
    <header
      className="sticky top-0 z-10 flex items-center justify-between border-b px-3 py-2"
      style={{
        background: 'var(--bg-surface)',
        borderColor: 'var(--border)',
      }}
      data-testid="calendar-header"
    >
      <button
        type="button"
        aria-label="Previous month"
        onClick={onPrev}
        className="flex min-h-[48px] min-w-[48px] items-center justify-center rounded-md border text-xl"
        style={{
          borderColor: 'var(--border)',
          color: 'var(--text-main)',
          background: 'transparent',
        }}
        data-testid="calendar-prev"
      >
        <span aria-hidden="true">‹</span>
      </button>
      <div className="flex flex-1 items-center justify-center gap-2 px-2">
        <span aria-hidden="true">📅</span>
        <h1
          className="text-center text-base font-semibold leading-tight"
          style={{ color: 'var(--text-main)' }}
          data-testid="calendar-month-label"
        >
          {monthLabel}
        </h1>
      </div>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={onToday}
          className="flex min-h-[48px] items-center justify-center rounded-md border px-3 text-sm font-medium"
          style={{
            borderColor: 'var(--border)',
            color: 'var(--accent)',
            background: 'transparent',
          }}
          data-testid="calendar-today"
        >
          Today
        </button>
        <button
          type="button"
          aria-label="Next month"
          onClick={onNext}
          className="flex min-h-[48px] min-w-[48px] items-center justify-center rounded-md border text-xl"
          style={{
            borderColor: 'var(--border)',
            color: 'var(--text-main)',
            background: 'transparent',
          }}
          data-testid="calendar-next"
        >
          <span aria-hidden="true">›</span>
        </button>
      </div>
    </header>
  );
}
